// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --checkboxSize: 1.125rem;
  --focusOutlineFF: 2px auto Highlight;
  --focusOutline: 2px auto -webkit-focus-ring-color;
  --focusOutlineOffset: 4px;
  --focusOutlineOffsetFF: 2px;
  --inputLineColor: var(--colorGrey40);
  --inputLabelColor: var(--colorGrey40);
  --inputIconWidth: 1.875rem;
  --inputBorderWidth: 2px;
  --inputEasingFn: ease;
  --inputTransitionTime: 0.28s;
  --selectHeight: 3rem;
}

:root {
  --spacer: 1rem;
  --eighth-spacer: calc(var(--spacer) / 8);
  --quarter-spacer: calc(var(--spacer) / 4);
  --three-quarter-spacer: calc(var(--spacer) * .75);
  --half-spacer: calc(var(--spacer) / 2);
  --almost-double-spacer: calc(var(--spacer) * 1.25);
  --one-and-half-spacer: calc(var(--spacer) * 1.5);
  --double-spacer: calc(var(--spacer) * 2);
  --two-and-half-spacer: calc(var(--spacer) * 2.5);
  --triple-spacer: calc(var(--spacer) * 3);
  --quad-spacer: calc(var(--spacer) * 4);
}

.checkbox {
  display: block;
  margin: calc(1.5rem) 0;
}

.checkbox .checkbox__container {
    border-radius: 0.125rem;
  }

.checkbox .checkbox__container:has(:focus-visible) {
    outline: 2px auto -webkit-focus-ring-color;
    outline-offset: 4px;
  }

@supports (-moz-appearance: none) {
    .checkbox .checkbox__container:has(:focus-visible) {
      outline: 2px auto Highlight;
      outline-offset: 2px;
    }
  }

.checkbox .checkbox__container {
    display: inline-block;
}

.checkbox .input__control + .input__label.indeterminate::before {
      background: #206dd2;
    }

.checkbox .input__control + .input__label.indeterminate::after {
      top: 0.5rem;
      left: 0.25rem;
      width: 0.75rem;
      height: 0.375rem;
      border: 2px solid #fff;
      border-top-style: none;
      border-right-style: none;
      border-left-style: none;
    }

.checkbox .input__control + .input__label.label-full-width {
      width: calc(100% - 1.5rem);
    }

.checkbox .input__control + .input__label.label-bold {
      font-weight: 700;
    }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
